export const GET_USER_BY_EMAIL = (email: string) =>
    `
    query {
        getUser(email: "${email}") {
            seq
            name
            email
            type
            isAdministrator
            company {
                businessNumber
            }
            thumbnail {
                name
                path
            }
        }
    }
    `;
